import { InertiaApp } from '@inertiajs/inertia-vue';
import PortalVue from 'portal-vue';
import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueRellax from 'vue-rellax';
import VueTimeago from 'vue-timeago';
import * as VueGoogleMaps from 'vue2-google-maps';
import TextHighlight from 'vue-text-highlight';
import Geocoder from '@pderas/vue2-geocoder';
import onlyInt from 'vue-input-only-number';
import Vuelidate from 'vuelidate';
import './scroll.helper';
import VueTippy from 'vue-tippy';
import {getCookie} from '@/cookie.helper';

window._ = require('lodash');
window.dateFns = require('date-fns');

Vue.config.productionTip = false;
Vue.mixin({ methods: { route: window.route } });
Vue.use(InertiaApp);
Vue.use(PortalVue);
Vue.use(VueMeta);
Vue.use(Vuelidate);
Vue.use(VueTippy);
Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'en',
  converter: (date) =>
    dateFns.differenceInDays(Date.now(), dateFns.parse(date)) + 1,
});
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB503OH-aBasz1gMcX8-15LxQY9VleZoA4',
    libraries: 'places',
    region: 'GE',
  },
  installComponents: false,
});
Vue.use(VueRellax);
Vue.use(Geocoder, {
  defaultCountryCode: 'GE',
  defaultLanguage: 'ka',
  defaultMode: 'address',
  googleMapsApiKey: 'AIzaSyB503OH-aBasz1gMcX8-15LxQY9VleZoA4',
});
Vue.use(onlyInt);

Vue.component('text-highlight', TextHighlight);

Vue.mixin({
  methods: {
    //
    __(key, replace = {}) {
      let translation = this.$page.language[key]
        ? this.$page.language[key]
        : key;

      Object.keys(replace).forEach(function (key) {
        translation = translation.replace(':' + key, replace[key]);
      });

      return translation;
    },

    //
    __n(key, num, replace = {}) {
      const options = key.split('|');

      key = options[1];

      if (num === 1) {
        key = options[0];
      }

      return tt(key, replace);
    },

    //
    ka2en(str) {
      if (this.$page.locale === 'ka') {
        return str;
      }

      const from = [
        'ა',
        'ბ',
        'გ',
        'დ',
        'ე',
        'ვ',
        'ზ',
        'თ',
        'ი',
        'კ',
        'ლ',
        'მ',
        'ნ',
        'ო',
        'პ',
        'ჟ',
        'რ',
        'ს',
        'ტ',
        'უ',
        'ფ',
        'ქ',
        'ღ',
        'ყ',
        'შ',
        'ჩ',
        'ც',
        'ძ',
        'წ',
        'ჭ',
        'ხ',
        'ჯ',
        'ჰ',
      ];
      const to = [
        'a',
        'b',
        'g',
        'd',
        'e',
        'v',
        'z',
        't',
        'i',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'j',
        'r',
        's',
        't',
        'u',
        'f',
        'q',
        'g',
        'k',
        'sh',
        'ch',
        'ts',
        'dz',
        'ts',
        'j',
        'kh',
        'j',
        'h',
      ];

      let transformedStr = '';

      for (let i = 0; i < str.length; i++) {
        const index = from.indexOf(str[i]);
        transformedStr += index >= 0 ? to[index] : str[i];
      }

      return transformedStr
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
  },
});

window.EventBus = new Vue();

const app = document.getElementById('app');

window.app = new Vue({
  metaInfo: {
    titleTemplate: (title) => title || 'Superhero ∙ სუპერგმირი',
  },
  render: (h) =>
    h(InertiaApp, {
      props: {
        initialPage: JSON.parse(app.dataset.page),
        resolveComponent: (name) =>
          import(`@/Pages/${name}`).then((module) => module.default),
      },
    }),
}).$mount(app);
